/*
 * Public API Surface of cominication
 */

export * from './lib/cominication.service';
export * from './lib/cominication.component';
export * from './lib/cominication.module';
